module.exports = __webpack_public_path__ + "img/arrow-end.331f2b36.svg";